import { FULFILLABLE_RESERVATION_SECTION_IDS, type ReservationSectionId } from '@/wabunka-src/common/features/Reservation/core/requiredFields/sections';

/** アコーディオンに並ぶ順序。Continue で次に開くセクションはこの順序だけで決まる */
export const RESERVATION_SECTION_ORDER: readonly ReservationSectionId[] = [...FULFILLABLE_RESERVATION_SECTION_IDS, 'payment'];

export const nextReservationSectionId = (sectionId: ReservationSectionId): ReservationSectionId | null =>
  RESERVATION_SECTION_ORDER[RESERVATION_SECTION_ORDER.indexOf(sectionId) + 1] ?? null;

export const isReservationSectionBefore = (sectionId: ReservationSectionId, otherSectionId: ReservationSectionId): boolean =>
  RESERVATION_SECTION_ORDER.indexOf(sectionId) < RESERVATION_SECTION_ORDER.indexOf(otherSectionId);
